import { SbMediaDevices } from 'sb-lib/media-devices';
import { makeLog } from './log';
import { TwilioVideoProcessor } from 'shared/realtime/twilio-video-processor';

const log = makeLog('media-devices');
export const mediaDevices = new SbMediaDevices(log);
if (TwilioVideoProcessor.isSupported()) {
  mediaDevices.setVideoEffectProcessor(new TwilioVideoProcessor());
}

export * from 'sb-lib/media-devices';
